import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  padding: ", " ", ";\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  justify-content: center;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: ", ";\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  right: 0;\n  top: 0;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  flex-shrink: 0;\n  margin: 0 ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  flex-basis: 0; /* IE11 fix */\n  flex-grow: 1;\n  flex-shrink: 1;\n  margin: ", ";\n  min-width: 0;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  margin-right: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      border-radius: 0;\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      border: ", " dashed ", ";\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  overflow: hidden;\n\n  ", ";\n\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React from 'react';
import styled, { css } from 'styled-components';
import { Icon } from '@scp/ui-shared/theme/icons';
import { withoutProps } from '@scp/ui-shared/core/hoc';
import { withRippleEffect } from '@scp/ui-shared/theme/ripple-effect';
import { color } from '@scp/ui-shared/theme/variables';
import { getE2eLabel } from '@scp/ui-shared/components/utils';
import { rem, baselineToRem } from '@scp/ui-shared/theme/utils';
import { Paper } from './Paper';
import { Highlighter } from './Highlighter';
import { ClickableRow } from './buttons/ClickableRow';
import { KebabMenu } from './menu/KebabMenu';
var PROPS_TO_OMIT = ['dashedBorder'];
var CardWrapper = styled(Paper).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !PROPS_TO_OMIT.includes(prop);
  }
})(_templateObject(), function (_ref) {
  var dashedBorder = _ref.dashedBorder;
  return dashedBorder && css(_templateObject2(), rem(1), color.indicator);
}, function (_ref2) {
  var noBorder = _ref2.noBorder;
  return noBorder && css(_templateObject3());
});
var BaseContentWrapper = styled.div(_templateObject4());
var Content = styled.div(_templateObject5(), function (props) {
  return props.hasIcons ? baselineToRem(10) : 0;
});
var InnerContent = styled.div(_templateObject6(), function (_ref3) {
  var _ref3$innerVerticalMa = _ref3.innerVerticalMargin,
      innerVerticalMargin = _ref3$innerVerticalMa === void 0 ? 10 : _ref3$innerVerticalMa,
      _ref3$innerHorizontal = _ref3.innerHorizontalMargin,
      innerHorizontalMargin = _ref3$innerHorizontal === void 0 ? 24 : _ref3$innerHorizontal;
  return "".concat(innerVerticalMargin, "px ").concat(innerHorizontalMargin, "px");
});
var CardIcon = styled(Icon)(_templateObject7(), baselineToRem(2));
var KebabWrapper = styled.div(_templateObject8());
var IconContainer = styled.div(_templateObject9(), baselineToRem(10));
var Footer = styled.div(_templateObject10(), color.backgroundSecondary, baselineToRem(1), baselineToRem(6));
var Header = Footer; // Styles are identical. Will separate once needed.

var resolveIconName = function resolveIconName(_ref4) {
  var href = _ref4.href,
      isExternalAction = _ref4.isExternalAction,
      onClick = _ref4.onClick,
      to = _ref4.to,
      actionIconName = _ref4.actionIconName;

  if (!href && !onClick && !to) {
    return null;
  }

  if (actionIconName) return actionIconName;
  if (href || isExternalAction) return 'launch';
  return 'keyboard-arrow-right';
};

export function Card(_a) {
  var children = _a.children,
      onClick = _a.onClick,
      to = _a.to,
      headerContent = _a.headerContent,
      href = _a.href,
      highlightColor = _a.highlightColor,
      _a$dashedBorder = _a.dashedBorder,
      dashedBorder = _a$dashedBorder === void 0 ? false : _a$dashedBorder,
      actions = _a.actions,
      isExternalAction = _a.isExternalAction,
      innerHorizontalMargin = _a.innerHorizontalMargin,
      innerVerticalMargin = _a.innerVerticalMargin,
      dataE2e = _a.dataE2e,
      footerContent = _a.footerContent,
      noBorder = _a.noBorder,
      actionIconName = _a.actionIconName,
      _a$isActive = _a.isActive,
      isActive = _a$isActive === void 0 ? false : _a$isActive,
      rest = __rest(_a, ["children", "onClick", "to", "headerContent", "href", "highlightColor", "dashedBorder", "actions", "isExternalAction", "innerHorizontalMargin", "innerVerticalMargin", "dataE2e", "footerContent", "noBorder", "actionIconName", "isActive"]);

  var iconName = resolveIconName({
    href: href,
    to: to,
    onClick: onClick,
    isExternalAction: isExternalAction,
    actionIconName: actionIconName
  });
  var icon = iconName && React.createElement(CardIcon, {
    name: iconName
  });
  var baseContent = React.createElement(BaseContentWrapper, null, headerContent && React.createElement(Header, null, headerContent), React.createElement(Highlighter, {
    rounded: true,
    enabled: !!highlightColor,
    position: "left",
    customColor: highlightColor
  }, React.createElement(Content, {
    hasIcons: actions && actions.length > 0 || !!icon
  }, React.createElement(InnerContent, {
    innerHorizontalMargin: innerHorizontalMargin,
    innerVerticalMargin: innerVerticalMargin
  }, children), icon && React.createElement(IconContainer, null, icon)), footerContent && React.createElement(Footer, null, footerContent)));

  var clickableContent = function clickableContent() {
    if (!!href) {
      return React.createElement(ClickableRow, {
        href: href,
        target: "_blank",
        onClick: onClick,
        isActive: isActive
      }, baseContent);
    }

    if (!!to) {
      return React.createElement(ClickableRow, {
        to: to,
        isActive: isActive
      }, baseContent);
    }

    if (!!onClick) {
      return React.createElement(ClickableRow, {
        onClick: onClick,
        onKeyDown: function onKeyDown(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onClick();
          }
        },
        // Do not use LinkOrButton - it can have divs inside, so button wouldn't be a correct html element
        as: withoutProps(withRippleEffect('div'), ['isActive', 'dataE2e']),
        role: "button",
        tabIndex: 0,
        isActive: isActive
      }, baseContent);
    }

    return null;
  };

  return React.createElement(CardWrapper, Object.assign({
    padding: 0,
    "data-e2e": getE2eLabel(dataE2e),
    dashedBorder: dashedBorder,
    noBorder: noBorder
  }, rest), clickableContent() || baseContent, actions && actions.length > 0 && React.createElement(KebabWrapper, null, React.createElement(KebabMenu, {
    actions: actions
  })));
}